<div class="w-full h-full flex flex-col justify-center items-center">
  <mat-icon class="text-red-500" [attr.data-cy]="item?.dataCy + '-error-icon'">error</mat-icon>
  <span class="text-red-500 text-lg mx-2" [attr.data-cy]="item?.dataCy + '-error'">{{error}}</span>
</div>
